import PropTypes from 'prop-types';
import { iconsList } from '../../../icon/glyphs';
import { TYPES } from '../../../icon/constants';
import { TreeViewActionType } from '../../constants/types';

export const BaseTreeViewItemProps = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  iconGlyph: PropTypes.oneOf(iconsList).isRequired,
  hoverIconGlyph: PropTypes.oneOf(iconsList),
  iconType: PropTypes.oneOf(Object.values(TYPES)),
  actions: PropTypes.arrayOf(TreeViewActionType),
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  isDragging: PropTypes.bool,
  draggable: PropTypes.bool,
  isEmpty: PropTypes.bool,
  highlighted: PropTypes.bool,
  connectDragSource: PropTypes.func,
  customIconGlyph: PropTypes.node,
};
